import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    className?: string;
    vendor: {
        name: string;
        logo: {v_log_120x90: string};
        logo_url: string | null;
    } | null;
    offer: {
        name: string;
    } | null;
    onCloseModal: (forceClose?: boolean) => void;
}

export const ApplicationGoodbyeContentVendorDisplay = (props: IProps) => {
    const {className, vendor, offer, onCloseModal} = props;

    if (vendor && offer) {
        return (
            <div className={cx(vendorDisplayStyle, className)}>
                <Image
                    src={getThumbnailLink(vendor.logo_url, 120, 90) ?? vendor.logo.v_log_120x90}
                    alt={vendor.name}
                    width="96px"
                    height="64px"
                    ratio={{xs: "96/64"}}
                    className={imageStyle}
                />
                <div className={vendorOfferNameStyle}>
                    <Text variant="headline_6" strong className="bt">
                        {offer.name}
                    </Text>
                    <Text color="var(--colors-gray-700)" variant="body_copy_2" className={cx("bt", vendorNameStyle)}>
                        {vendor.name}
                    </Text>
                </div>

                <button
                    type="button"
                    className={closeButtonStyle}
                    onClick={() => onCloseModal(false)}
                    data-testid={OFFER_TEST_IDS.PHONE_CONTACT_MODAL.PHONE_CONTACT_MODAL_CLOSE_BUTTON}
                >
                    <CloseIcon size="2.4" />
                </button>
            </div>
        );
    }

    return (
        <button
            type="button"
            className={closeButtonStyle}
            onClick={() => onCloseModal(false)}
            data-testid={OFFER_TEST_IDS.PHONE_CONTACT_MODAL.PHONE_CONTACT_MODAL_CLOSE_BUTTON}
        >
            <CloseIcon size="2.4" />
        </button>
    );
};

const vendorDisplayStyle = css({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "6.4rem",
    maxHeight: "6.4rem"
});

const imageStyle = css({
    flex: "0 0 9.6rem"
});

const vendorOfferNameStyle = css({
    pl: 2,
    pt: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    maxWidth: "25rem"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});

const vendorNameStyle = css({
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
});
import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

interface IProps {
    className?: string;
    vendor: {
        name: string;
        logo: {v_log_120x90: string};
        logo_url: string | null;
    } | null;
    offer: {
        name: string;
    } | null;
    onCloseModal: (forceClose?: boolean) => void;
}

export const ApplicationGoodbyeContentVendorDisplay = (props: IProps) => {
    const {className, vendor, offer, onCloseModal} = props;

    if (vendor && offer) {
        return (
            <div className={cx(vendorDisplayStyle, className)}>
                <Image
                    src={getThumbnailLink(vendor.logo_url, 120, 90) ?? vendor.logo.v_log_120x90}
                    alt={vendor.name}
                    width="96px"
                    height="64px"
                    ratio={{xs: "96/64"}}
                    className={imageStyle}
                />
                <div className={vendorOfferNameStyle}>
                    <Text variant="headline_6" strong className="bt">
                        {offer.name}
                    </Text>
                    <Text color="var(--colors-gray-700)" variant="body_copy_2" className={cx("bt", vendorNameStyle)}>
                        {vendor.name}
                    </Text>
                </div>

                <button
                    type="button"
                    className={closeButtonStyle}
                    onClick={() => onCloseModal(false)}
                    data-testid={OFFER_TEST_IDS.PHONE_CONTACT_MODAL.PHONE_CONTACT_MODAL_CLOSE_BUTTON}
                >
                    <CloseIcon size="2.4" />
                </button>
            </div>
        );
    }

    return (
        <button
            type="button"
            className={closeButtonStyle}
            onClick={() => onCloseModal(false)}
            data-testid={OFFER_TEST_IDS.PHONE_CONTACT_MODAL.PHONE_CONTACT_MODAL_CLOSE_BUTTON}
        >
            <CloseIcon size="2.4" />
        </button>
    );
};

const vendorDisplayStyle = css({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "6.4rem",
    maxHeight: "6.4rem"
});

const imageStyle = css({
    flex: "0 0 9.6rem"
});

const vendorOfferNameStyle = css({
    pl: 2,
    pt: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    maxWidth: "25rem"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});

const vendorNameStyle = css({
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
});
